import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Box, Chip, Tab, Tooltip, Typography, } from "@mui/material";
import { PrimaryGrid } from "@ui/components/grid/PrimaryGrid";
import { between, colCenter, rowCenter } from "@ui/style/style";
import { PIconButton } from "@ui/components/buttons/PIconButton";
import { Icon } from "@iconify/react";
import { Eye, Link1, Setting4, Trash, ArchiveBox } from "iconsax-react";
import { FamilyForm } from "./FamilyForm";
import { getAvailablePageSizes } from "@application/helpers/primary-grid-utility";
import { APIStatus } from "@application/common/enums/api-status";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { archivingTogglingInvitationAsync, deleteInvitationAsync, getAllInvitationCountAsync, getInvitationStatsAsync, getPaginatedInvitationsByEventIdAsync, } from "@application/features/invitation/invitationThunk";
import { clearInvitationStats, clearPaginatedInvitations, } from "@application/features/invitation/invitationSlice";
import { InvitationStatList } from "../directors/InvitationStatList";
import { PButton } from "@ui/components/buttons/PButton";
import { InvitationAccessDialog } from "../directors/InvitationAccessDialog";
import { getEventPublicAccessInfoAsync } from "@application/features/Event/EventThunk";
import { clearPublicAccessInfo } from "@application/features/Event/EventSlice";
import { toast } from "react-toastify";
import { ExportToExcel } from "../ExportToExcel";
import { ConfirmDialog } from "@ui/components/dialog/ConfDialog";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { TabTitle } from "@ui/components/tabs/TabTitle";
import { useLocation } from "react-router-dom";
export const Internals = ({ eventId, searchedInvitationId, }) => {
    const isInitialLoad = useRef(true);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const [selectedItem, setSelectedItem] = useState(null);
    const { status, paginatedInvitations } = useAppSelector((state) => state.invitation);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [idsToDelete, setIdsToDelete] = useState([]);
    const [idsToArchivingtoggling, setIdsToArchivingtoggling] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedSearchParam, setSelectedSearchParam] = useState(null);
    const [SelectedParams, setSelectedParams] = useState(null);
    const [isAccessDialogOpen, setIsAccessDialogOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 20,
    });
    const theme = useTheme();
    const location = useLocation();
    const isMd = useMediaQuery(theme.breakpoints.down("lg"));
    const isBelow900 = useMediaQuery(theme.breakpoints.down(901));
    const [activeTab, setActiveTab] = useState(location.state?.targetTab === "archived" ? "archived" : "active");
    const [confirmDialogConfig, setConfirmDialogConfig] = useState(null);
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        setSelectedRows([]);
    };
    const tabConfigs = [
        {
            key: "active",
            label: t("admin.active"),
        },
        {
            key: "archived",
            label: t("admin.archived"),
        },
    ];
    useEffect(() => {
        if (eventId) {
            if (isInitialLoad.current) {
                dispatch(clearPaginatedInvitations());
                dispatch(clearInvitationStats());
                dispatch(getInvitationStatsAsync(eventId));
                isInitialLoad.current = false;
            }
            // Fetch paginated data
            dispatch(getPaginatedInvitationsByEventIdAsync({
                eventId: eventId,
                InvitationId: searchedInvitationId ?? null,
                page: paginationModel.page + 1,
                pageSize: paginationModel.pageSize,
                invitationStatus: selectedStatus,
                searchParam: selectedSearchParam,
                isArchived: activeTab === "archived",
                isExportMode: false,
            }))
                .unwrap()
                .then((response) => {
                const obj = {
                    eventId: eventId,
                    page: paginationModel.page + 1,
                    pageSize: paginationModel.pageSize,
                    invitationStatus: selectedStatus,
                    searchParam: selectedSearchParam,
                };
                setSelectedParams(obj);
            });
        }
    }, [
        eventId,
        paginationModel.page,
        paginationModel.pageSize,
        selectedStatus,
        selectedSearchParam,
        searchedInvitationId,
        activeTab,
    ]);
    useEffect(() => {
        if (eventId) {
            dispatch(clearPublicAccessInfo());
            dispatch(getEventPublicAccessInfoAsync(eventId));
        }
    }, [dispatch]);
    useEffect(() => {
        if (location.state?.targetTab) {
            setActiveTab(location.state.targetTab);
        }
    }, [location.state?.targetTab]);
    const columns = [
        {
            field: "fullName",
            headerName: t("admin.familyFest.name"),
            flex: 1,
            minWidth: 150,
        },
        {
            field: "companyName",
            headerName: t("admin.familyFest.company"),
            flex: 1,
            minWidth: 150,
        },
        {
            field: "userEmail",
            headerName: t("admin.familyFest.contact"),
            flex: 1.2,
            renderCell: (params) => (_jsx(Box, { sx: { ...colCenter, height: "100%" }, children: _jsx(Typography, { variant: "subtitle2", color: "text.primary", children: params.row.userEmail }) })),
            minWidth: 150,
        },
        {
            field: "totalPersonInvited",
            headerName: t("admin.familyFest.family"),
            flex: 0.8,
            minWidth: 100,
            align: "center",
            headerAlign: "center",
        },
        {
            field: "status",
            headerName: t("admin.familyFest.status"),
            flex: 1,
            headerAlign: "center",
            align: "center",
            renderCell: (params) => {
                const getStatusInfo = (status) => {
                    switch (status) {
                        case 1:
                            return {
                                label: t("admin.stats.invited"),
                                variant: "soft",
                                color: "default",
                            };
                        case 2:
                            return {
                                label: t("admin.stats.inProgress"),
                                variant: "outlined",
                                color: "info",
                            };
                        case 3:
                            return {
                                label: t("admin.stats.registered"),
                                variant: "filled",
                                color: "success",
                            };
                        case 4:
                            return {
                                label: t("admin.stats.invited"),
                                variant: "soft",
                                color: "default",
                            };
                        case 5:
                            return {
                                label: t("admin.stats.expired"),
                                variant: "soft",
                                color: "error",
                            };
                        case 6:
                            return {
                                label: t("admin.stats.declined"),
                                variant: "soft",
                                color: "error",
                            };
                        default:
                            return {
                                label: t("admin.stats.unknown"),
                                variant: "filled",
                                color: "info",
                            };
                    }
                };
                const { label, variant, color } = getStatusInfo(params.row.status);
                return (_jsx(Chip, { size: "small", variant: variant, label: label, sx: { fontWeight: 500 }, color: color }));
            },
            minWidth: 120,
        },
        {
            field: "invitedDate",
            headerName: t("admin.familyFest.invitationDate"),
            flex: 1,
            renderCell: (params) => {
                return (_jsx(Box, { sx: { ...rowCenter, flexDirection: "column", height: "100%" }, children: _jsx(Typography, { variant: "subtitle2", color: "text.primary", children: params.row.invitedDate }) }));
            },
            minWidth: 130,
        },
        {
            field: "joiningDates",
            headerName: t("admin.familyFest.joiningDates"),
            flex: 0.8,
            renderCell: (params) => {
                const dates = params.row.joiningDates || [];
                if (dates.length > 0) {
                    return (_jsx(Tooltip, { placement: "right", title: _jsx(Box, { sx: { display: "flex", flexDirection: "column" }, children: dates.map((date, index) => (_jsx(Box, { children: date }, index))) }), arrow: true, children: _jsx(Chip, { label: `${dates.length}`, size: "medium", variant: "soft", color: "default" }) }));
                }
                else {
                    return (_jsx(Box, { sx: { ...rowCenter, flexDirection: "column", height: "100%" }, children: _jsx(Typography, { variant: "subtitle2", color: "text.primary", children: "N/A" }) }));
                }
            },
            minWidth: 120,
        },
        {
            field: "magicLink",
            headerName: t("admin.familyFest.magicLink"),
            sortable: false,
            flex: 0.4,
            headerAlign: "center",
            renderCell: (params) => (_jsx(Box, { sx: {
                    ...colCenter,
                    ...rowCenter,
                    flexDirection: "column",
                    height: "100%",
                }, children: params.row.magicLink ? (_jsx(PIconButton, { color: "#637381", border: "#919EAB29", size: "small", onClick: () => {
                        navigator.clipboard.writeText(params.row.magicLink);
                        toast.success(t("admin.familyFest.linkCopied"));
                    }, children: _jsx(Icon, { icon: "hugeicons:copy-01", width: "24", height: "24" }) })) : (_jsx(Typography, { variant: "subtitle2", color: "text.primary", children: t("Pending") })) })),
            minWidth: 120,
        },
        {
            field: "lastModifiedDate",
            sortable: false,
            headerName: t("admin.familyFest.lastModifiedDate"),
            flex: 0.8,
            minWidth: 120,
            renderCell: (params) => {
                const convertToLocalTime = (utcDate) => {
                    if (!utcDate)
                        return "N/A";
                    try {
                        const date = new Date(utcDate);
                        const timezoneOffset = date.getTimezoneOffset();
                        const localDate = new Date(date.getTime() - timezoneOffset * 60000);
                        return new Intl.DateTimeFormat(i18n.language, {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                            // hour: "2-digit",
                            // minute: "2-digit",
                            // hour12: true,
                        }).format(localDate);
                    }
                    catch (error) {
                        return "N/A";
                    }
                };
                return (_jsx(Box, { sx: { ...rowCenter, flexDirection: "column", height: "100%" }, children: _jsx(Typography, { variant: "subtitle2", color: "text.primary", children: convertToLocalTime(params.row.lastModifiedDate) }) }));
            },
        },
        {
            field: "action",
            headerName: t("admin.familyFest.action"),
            flex: 0.5,
            sortable: false,
            headerAlign: "center",
            renderCell: (params) => (_jsxs(Box, { sx: { ...colCenter, height: "100%", gap: 1.5 }, children: [_jsx(PIconButton, { border: "#919EAB29", color: "#637381", size: "small", onClick: () => handleView(params.row), children: _jsx(Eye, {}) }), _jsx(PIconButton, { border: "#E5232229", color: "#E52322", size: "small", onClick: () => openDeleteDialog(params.row.id), children: _jsx(Trash, {}) })] })),
            minWidth: 110,
        },
    ];
    const handleView = (row) => {
        setSelectedItem({
            id: row.id,
            userId: row.userId,
            name: row.fullName,
            company: row.companyName,
            email: row.userEmail,
            phone: row.userContactNo,
            invitationDate: row.invitedDate,
        });
        setDrawerOpen(true);
    };
    const handleDelete = async (ids) => {
        try {
            const response = await dispatch(deleteInvitationAsync({ invitationIds: ids })).unwrap();
            if (response.isSuccess && eventId) {
                toast.success(response.message);
                dispatch(getPaginatedInvitationsByEventIdAsync({
                    eventId,
                    InvitationId: searchedInvitationId ?? null,
                    page: paginationModel.page + 1,
                    pageSize: paginationModel.pageSize,
                    isArchived: activeTab === "archived",
                    isExportMode: false,
                }));
                dispatch(getInvitationStatsAsync(eventId));
                dispatch(getAllInvitationCountAsync());
                setSelectedRows([]);
            }
            else {
                toast.error(response.message);
            }
        }
        catch (error) {
            toast.error("Failed to delete invitation(s)");
        }
        finally {
            setConfirmDialogConfig(null);
        }
    };
    const openDeleteDialog = (ids) => {
        const deleteIds = ids && ids.length > 0 ? ids : selectedRows;
        if (deleteIds.length > 0) {
            setConfirmDialogConfig({
                isOpen: true,
                title: t("admin.familyFest.confirmDeletion"),
                bodyText: t("admin.familyFest.deleteConfirmation"),
                cancelAction: t("admin.familyFest.keepInvitation"),
                confirmAction: t("admin.familyFest.deleteInvitation"),
                onConfirm: () => handleDelete(deleteIds),
            });
        }
    };
    const openArchiveDialog = (ids, isArchiving) => {
        setConfirmDialogConfig({
            isOpen: true,
            title: isArchiving
                ? t("admin.familyFest.confirmArchiving")
                : t("admin.familyFest.confirmUnarchiving"),
            bodyText: isArchiving
                ? t("admin.familyFest.archiveConfirmation")
                : t("admin.familyFest.unarchiveConfirmation"),
            cancelAction: t("admin.familyFest.keepInvitation"),
            confirmAction: isArchiving
                ? t("admin.familyFest.archiveInvitation")
                : t("admin.familyFest.unarchiveInvitation"),
            onConfirm: () => handleArchiveToggle(ids),
        });
    };
    const handleArchiveToggle = async (ids) => {
        try {
            const response = await dispatch(archivingTogglingInvitationAsync({ invitationIds: ids })).unwrap();
            if (response.isSuccess && eventId) {
                toast.success(response.message);
                dispatch(getPaginatedInvitationsByEventIdAsync({
                    eventId,
                    InvitationId: searchedInvitationId ?? null,
                    page: paginationModel.page + 1,
                    pageSize: paginationModel.pageSize,
                    isArchived: activeTab === "archived",
                    isExportMode: false,
                }));
                dispatch(getInvitationStatsAsync(eventId));
                dispatch(getAllInvitationCountAsync());
                setSelectedRows([]);
            }
            else {
                toast.error(response.message);
            }
        }
        catch (error) {
            toast.error("Failed to archive/unarchive invitation(s)");
        }
        finally {
            setConfirmDialogConfig(null);
        }
    };
    const handleCloseDrawer = () => {
        setDrawerOpen(false);
    };
    const activeCount = paginatedInvitations?.activeCount ?? 0;
    const archivedCount = paginatedInvitations?.archivedCount ?? 0;
    return (_jsxs(Box, { sx: {
            background: "#FFFFFFCC",
            boxShadow: "0px 12px 24px -4px #919EAB1F",
            backdropFilter: "blur(20px)",
            borderRadius: 3,
            px: 2,
            py: 1.5,
            width: "100%",
        }, children: [_jsx(InvitationStatList, { eventType: "family", onStatusChange: (status) => setSelectedStatus(status), onParamChange: (searchParam) => setSelectedSearchParam(searchParam) }), _jsx(TabContext, { value: activeTab, children: tabConfigs.map((tab) => (_jsxs(TabPanel, { value: tab.key, children: [_jsxs(Box, { sx: {
                                ...between,
                                mt: 1,
                                flexDirection: "row",
                                [theme.breakpoints.down(701)]: {
                                    alignItems: selectedRows.length > 0 && "start",
                                    flexDirection: selectedRows.length > 0 ? "column" : "row",
                                    rowGap: 1,
                                },
                            }, children: [_jsx(TabList, { onChange: handleTabChange, "aria-label": "invitation tabs", variant: "scrollable", children: tabConfigs.map((tab, idx) => (_jsx(Tab, { label: _jsx(TabTitle, { number: tab.key === "active" ? activeCount : archivedCount, title: tab.label, value: tab.key, index: String(idx + 1) }), value: tab.key }, tab.key))) }), _jsxs(Box, { sx: {
                                        ...colCenter,
                                        gap: 1.5,
                                        justifyContent: "center",
                                        width: "auto",
                                        [theme.breakpoints.down(701)]: {
                                            width: selectedRows.length > 0 ? "100%" : "auto",
                                            justifyContent: "space-between",
                                        },
                                    }, children: [_jsxs(Box, { sx: {
                                                ...colCenter,
                                                width: "auto",
                                                justifyContent: "start",
                                                gap: 1.5,
                                                [theme.breakpoints.down(701)]: {
                                                    width: selectedRows.length > 0 ? "100%" : "auto",
                                                },
                                            }, children: [selectedRows.length > 0 && (_jsxs(Typography, { variant: "caption", color: "text.primary", children: [selectedRows.length, " ", t("admin.familyFest.selected")] })), selectedRows.length > 0 &&
                                                    (isBelow900 ? (_jsx(PIconButton, { border: "#E5232229", color: "#E52322", size: "small", onClick: () => openDeleteDialog(selectedRows), children: _jsx(Trash, {}) })) : (_jsx(PButton, { variant: "soft", size: "small", color: "error", onClick: () => openDeleteDialog(selectedRows), children: t("admin.familyFest.removeAll") }))), selectedRows.length > 0 &&
                                                    (isBelow900 ? (_jsx(PIconButton, { color: "#637381", size: "small", children: _jsx(ArchiveBox, {}) })) : (_jsx(PButton, { variant: "soft", size: "small", color: "primary", onClick: () => openArchiveDialog(selectedRows, activeTab === "active"), children: activeTab === "active"
                                                            ? t("admin.familyFest.archiveAll")
                                                            : t("admin.familyFest.activeAll") })))] }), _jsxs(Box, { sx: {
                                                ...colCenter,
                                                gap: 1.5,
                                            }, children: [paginatedInvitations?.invitationList?.totalCount != 0 &&
                                                    paginatedInvitations?.invitationList?.totalCount > 0 && (_jsx(ExportToExcel, { fileName: "family-fest-invitations", eventType: "family", selectedParams: SelectedParams, exportType: activeTab })), isMd ? (_jsx(PIconButton, { onClick: () => setIsAccessDialogOpen(true), size: "small", color: "#637381", children: _jsx(Link1, {}) })) : (_jsx(PButton, { startIcon: _jsx(Link1, {}), variant: "soft", size: "small", color: "primary", onClick: () => setIsAccessDialogOpen(true), children: t("admin.familyFest.invitationAccess") })), isMd ? (_jsx(PIconButton, { disabled: true, color: "#637381", size: "small", children: _jsx(Setting4, {}) })) : (_jsx(PButton, { size: "small", startIcon: _jsx(Setting4, {}), disabled: true, variant: "soft", color: "inherit", children: t("admin.familyFest.filters") }))] })] })] }), _jsx(PrimaryGrid, { columns: columns, checkboxSelection: true, paginationMode: "server", disableRowSelectionOnClick: true, paginationModel: paginationModel, loading: status === APIStatus.PENDING, rows: paginatedInvitations?.invitationList?.items || [], onPaginationModelChange: setPaginationModel, rowCount: paginatedInvitations?.invitationList?.totalCount ?? 0, pageSizeOptions: getAvailablePageSizes(paginatedInvitations?.invitationList?.totalCount ?? 0), initialState: {
                                columns: {
                                    columnVisibilityModel: {
                                        isActive: !(paginatedInvitations?.invitationList?.totalCount === 0),
                                    },
                                },
                            }, onRowSelectionModelChange: (newSelection) => {
                                setSelectedRows(newSelection);
                            } })] }, tab.key))) }), _jsx(FamilyForm, { open: drawerOpen, onClose: handleCloseDrawer, selectedInvitation: selectedItem
                    ? {
                        id: selectedItem.id.toString(),
                        userId: selectedItem.userId,
                    }
                    : undefined }), _jsx(InvitationAccessDialog, { isOpen: isAccessDialogOpen, onClose: () => setIsAccessDialogOpen(false) }), _jsx(ConfirmDialog, { isOpen: !!confirmDialogConfig?.isOpen, onClose: () => setConfirmDialogConfig(null), onConfirm: confirmDialogConfig?.onConfirm ?? (() => { }), title: confirmDialogConfig?.title || "", bodyText: confirmDialogConfig?.bodyText || "", cancelAction: confirmDialogConfig?.cancelAction || "", confirmAction: confirmDialogConfig?.confirmAction || "" })] }));
};
